(function () {
    'use strict';

    function AdminUsersCtrl(restangular, toastr, $scope, $uibModal) {
        var vm = this;

        vm.searchOptions = {
            size: 10,
            page: 1,
            roleId: null
        };

        vm.removeUser = removeUser;
        vm.saveUser = saveUser;
        vm.roles = [];

        vm.selectedRole = selectedRole;

        restangular.all('users').one('roles').getList().then(function (data) {
            vm.roles = data;
        });

        $scope.$watch(function () { return vm.searchOptions; }, fetch, true);

        /////////////////////////////////////
        function fetch() {
            restangular
                .one('users')
                .get(vm.searchOptions)
                .then(function (users) {
                    vm.users = users;
                });
        }

        function saveUser(user) {
            restangular
                .one('users', user.id)
                .post('setrole', JSON.stringify(user.roles[0].roleId)).then(function () {
                    toastr.info('User has been updated', 'User updated');
                    fetch();
                }, function() {
                    toastr.error('Unable to update user role.', 'Error');
                    user.edit = false;
                });
        }

        function removeUser(user) {
            $uibModal.open({ templateUrl: 'admin/users/confirmation.html' }).result.then(function () {
                restangular.one('users', user.id).customDELETE().then(function () {
                    toastr.info('User has been removed.', 'User removed');
                    fetch();
                }, function () {
                    toastr.error('Unable to remove document.', 'Error');
                });
            });

        }

        function selectedRole() {
            if (!vm.roles) return 'users';
            
            return vm.searchOptions.roleId == null
                ? 'users'
                : _.get(_.find(vm.roles, { id: vm.searchOptions.roleId }), 'name') + 's';
        }
    };

    angular
        .module('app')
        .controller('AdminUsersCtrl', ['Restangular', 'toastr', '$scope', '$uibModal', AdminUsersCtrl]);

})();